import Subject from "../cse4sub/Subject";
import React from 'react'
import cse from '../assets/ECE305end21.pdf'
import csm from '../assets/ECE305mid21.pdf'

export default function Ss() {
  return (
    <div>
       <Subject title="Signal & Systems(ECE305)" sub="Compiler Design" syllabus="#"mid="Q. Paper"
    book1=" " book2=" "
    book1Link="#" book2Link="#" int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}